var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myTitle-tem flex align-items justify-content-between",class:{ 'text-2': _vm.type == 2 }},[_c('h3',{staticClass:"flex align-items"},[_c('span',{staticClass:"icon rotate"}),_vm._v("\n    "+_vm._s(_vm.title)+"\n    ")]),_c('span',{staticClass:"uuid"},[_vm._t("uuid")],2),(_vm.right)?[_vm._t("tab")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }